
<div class="h-full flex flex-col bg-extend-onPrimary text-extend-onGrayPrimary main-navigation">
  <!-- Logo at the top-->
  <div class="w-full p-4 flex items-center justify-center">
    <img src="assets/logo/secomp-logo-icon.svg" alt="Logo" class="max-h-10" onerror="this.style.display='none'">
  </div>

  <nav class="pt-3">
    @for (navItem of mainNavigationItems$ | async; track navItem) {
      <div class="navigation-item-text sub-navigation-hover w-full pl-8 pr-3 py-2 cursor-pointer flex items-center justify-between"
           [title]="navItem.title"
           (click)="toggle(navItem)"
           [attr.aria-expanded]="!navItem.collapsed">
        <span class="font-medium">{{ navItem.title }}</span>
        <span class="ml-2 text-sm" aria-hidden="true">
          <i class="fas"
             [class.fa-chevron-down]="navItem.collapsed"
             [class.fa-chevron-up]="!navItem.collapsed"></i>
        </span>
      </div>
      @if (navItem.children && !navItem.collapsed) {
        <div class="pb-2">
          @for (sub of navItem.children; track sub) {
            <a class="block navigation-item-text sub-navigation-hover w-full pl-12 pr-3 py-2"
               [routerLink]="sub.link"
               routerLinkActive="active-main-nav"
               [routerLinkActiveOptions]="{exact: true}">{{ sub.title }}</a>
          }
        </div>
      }
    }
  </nav>
  <!--<div>
    <div class="navigation-item-text main-navigation-hover w-full px-3 py-1 cursor-pointer" title="Logout" (click)="logout()">Logout</div>
  </div> -->
</div>
